import script from "./FilterTareas.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterTareas.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__